export class Region {

    constructor(readonly countryId: number, readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Region.ts